// efで離脱時にだすアラートのイベント解除に使う
export var efUnloadEvent = function (event) {
    event.returnValue = '';
    return '';
};
